import React from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import * as _ from 'lodash';
import {
  LocationDropdown,
  Wrap,
  Loader,
  ErrorDisplay,
  Typography,
  Popup,
} from '../../components/index';
import Styled from './Rewards.style';
import { useTranslation } from 'react-i18next';
import { useResponsivity, scrollToTop } from '../../helpers/helpers';
import store from 'store2';
import TaskForm from './TaskForm';
type ProductProps = {
  id: number;
  description: string;
  buttonText: string;
  tag: string;
  icon: string;
  formElements: any;
};
interface RewardsProps {
  challenges: any;
  listLocation: any;
  getOffers: Function;
  setMeta: Function;
  postLeakRepairSignup: Function;
  leakFixSignup: any;
}
const Rewards: React.FC<RewardsProps> = (props) => {
  const {
    challenges,
    listLocation,
    setMeta,
    getOffers,
    postLeakRepairSignup,
    leakFixSignup,
  } = props;
  const [showPopup, setPopup] = React.useState(false);
  const isMobile = useResponsivity();
  const data = _.get(challenges, 'offers.data.challenges');
  const [productId, setProductId] = React.useState<ProductProps | null>(null);
  const [t] = useTranslation('common');
  const title = 'Actions';

  const dataLocation = _.get(listLocation, 'data.data');
  const getLocationId = _.get(listLocation, 'data.data[0].id');
  const dataLength = _.get(dataLocation, 'length');
  const { loading, error } = _.get(challenges, 'status');
  const getValue = store.get('property');

  const [value, setValue] = React.useState(`${getValue}`);
  const renderMapOptions =
    dataLocation &&
    dataLocation.map((el) => ({
      value: el.id,
      label: el.property_name,
    }));
  React.useEffect(() => {
    if (getValue === 'all') {
      store('property', getLocationId);
    }
    scrollToTop();
  }, [getValue, getLocationId]);
  React.useEffect(() => {
    if (!getValue) {
      store('property', getLocationId);
    } else if (dataLength === 1) {
      getOffers(getLocationId);
    } else if (getValue) {
      getOffers(getValue);
    }
  }, [getValue, getLocationId]);

  if (loading) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }
  if (error) {
    return (
      <Wrap>
        <ErrorDisplay />
      </Wrap>
    );
  }

  const renderOffers = () => {
    return (
      data &&
      data.map((el, index) => {
        return (
          <Col
            md={6}
            xs={12}
            sm={12}
            key={index}
            style={{ marginBottom: '16px' }}
          >
            <Styled.OfferWrap>
              <Row>
                <Col md={6} xs={12} sm={12}>
                  <Typography size="3" text={el.title} />
                </Col>
                {el.imageUrl !== null && (
                  <Col
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <img
                      src={`https://cdn.getwaterfit.co.uk/static/files/logos/business/${el.imageUrl}-color.png`}
                      alt={el.imageUrl}
                      style={{
                        height: '30px',
                      }}
                    />
                  </Col>
                )}
              </Row>
              <Typography size="p" text={el.description} />
              <Styled.CustomButton
                onClick={() => {
                  if (el.type.includes('externalLink')) {
                    window.open(el.buttonPath, '_blank');
                  } else if (el.type.includes('form')) {
                    setPopup(true);
                    setProductId(el);
                  }
                }}
              >
                {el.buttonText}
              </Styled.CustomButton>
            </Styled.OfferWrap>
          </Col>
        );
      })
    );
  };
  return (
    <Wrap>
      <Row>
        <Col md={8} sm={12} xs={12}>
          <Popup isDesktop={!isMobile} open={showPopup} handleClick={setPopup}>
            {productId && (
              <TaskForm
                postLeakRepairSignup={postLeakRepairSignup}
                isDesktop={!isMobile}
                description={t(productId.description)}
                buttonText={productId.buttonText}
                formElements={productId.formElements}
                icon={productId.icon}
                id={productId.id}
                tag={productId.tag}
                leakFixSignup={leakFixSignup}
              />
            )}
          </Popup>
          <Typography
            size="1"
            weight={700}
            text={title}
            style={{
              marginBottom: '16px',
              fontSize: '40px',
              color: '#0b2641',
            }}
          />
        </Col>
        {dataLength <= 1 ? null : (
          <Col md={4} xs={12} sm={12}>
            <Styled.DropdownWrap>
              <LocationDropdown
                value={value === getValue ? value : getValue}
                onChange={(e) => {
                  e.preventDefault();
                  setValue(e.target.value);
                  store('property', e.target.value);
                  setMeta(getValue);
                }}
                options={renderMapOptions}
              />
            </Styled.DropdownWrap>
          </Col>
        )}
      </Row>
      <Row>{renderOffers()}</Row>
    </Wrap>
  );
};
export default Rewards;
